// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"domains_modal-container__1Qgzy","input-label":"domains_input-label__Mulzt","input-wrapper":"domains_input-wrapper__1AnZA"};